/**
 * Configures the shared Axios client used across the admin dashboard.
 *
 * Components historically imported Axios directly, so creating a separate
 * client would leave existing protected calls unauthenticated. A single,
 * idempotent interceptor keeps every request in sync with the current session.
 */
import axios from "axios";
import { getToken } from "./embedAuth";

const INSTALL_FLAG = "__okbotAdminAuthInterceptorInstalled";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function isBackendRequest(url, baseURL) {
  try {
    const browserOrigin = window.location.origin;
    const backendOrigin = new URL(BACKEND_URL || browserOrigin, browserOrigin).origin;
    const requestBase = baseURL
      ? new URL(baseURL, browserOrigin).toString()
      : browserOrigin;
    const requestOrigin = new URL(url || "", requestBase).origin;
    return requestOrigin === backendOrigin;
  } catch (_) {
    // Do not attach an admin credential when a target cannot be validated.
    return false;
  }
}

export function configureAuthenticatedRequests() {
  if (axios[INSTALL_FLAG]) return;

  axios.interceptors.request.use((config) => {
    const token = getToken();
    if (token && isBackendRequest(config.url, config.baseURL)) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  });

  axios[INSTALL_FLAG] = true;
}